import React from 'react';
import CKEditor from 'ckeditor4-react';
import conf from '../../config';
import store from 'store2';
import $ from 'jquery';
import UiComponent from '../../common/UiComponent';

const userAuth = store.get('user');


export default class CKEditorComponent extends UiComponent {

  constructor(props) {
    super(props);
    this.state = {
      editor: null
    };
  }

  shouldComponentUpdate(nextProps) {
    // WORKAROUND to set properly data
    if (nextProps.field.value !== this.props.field.value && this.state.editor) {
      const editor = this.state.editor;
      editor.setData(nextProps.field.value, {
        callback: () =>{ editor.setData(nextProps.field.value); }
      });
    }
    return true
  }

  addPopover(container) {
    container.popover({
      placement: "right",
      trigger: "hover",
    });
  }

  deletePopover(container) {
    container.popover('dispose');
  }

  componentWillUnmount() {
    this.deletePopover($('.icon-has-popover'));
  }

  componentDidMount() {
    const iconWithPopover = $('.icon-has-popover');
    this.deletePopover(iconWithPopover);
    this.addPopover(iconWithPopover);
  }

  componentDidUpdate() {
    const iconWithPopover = $('.icon-has-popover');
    this.deletePopover(iconWithPopover);
    this.addPopover(iconWithPopover);
  }

  render() {
    const {refLink, field} = this.props;
    const ownState = this.state;

    const apiEndpoint = conf ? conf.apiEndpoint : '';

    return (
      <div>
        {this.getLabel()}
        <i
          data-content={field.helper}
          className="material-icons icon-has-popover"
          style={{
            position: 'relative',
            top: '2px',
            left: '7px',
            fontSize: '16px',
            cursor: 'pointer',
          }}
        >
          help
        </i>
        <CKEditor
          onBeforeLoad={(x) => {x.disableAutoInline = true;}}
          data={field.value}
          ref={refLink}
          onloaded={x => {ownState.editor = x.editor;}}
          type={'image2,uploadimage'}
          onChange={this.upload}
          readOnly={this.props.disabled}
          config={{
            extraPlugins: 'image2,uploadimage',
            uploadUrl: `${apiEndpoint}/ckeditor/upload`,
            fileTools_requestHeaders: {'Authorization': `bearer ${userAuth ? userAuth.api_token : 'nothing'}`},
            // filebrowserBrowseUrl:  `${apiEndpoint}/ckeditor/upload`,
            // filebrowserImageBrowseUrl:  `${apiEndpoint}/ckeditor/upload`,
            filebrowserUploadUrl: `${apiEndpoint}/ckeditor/upload`,
            filebrowserImageUploadUrl:  `${apiEndpoint}/ckeditor/upload`,
            versionCheck: false,

            format_tags: 'p;h1;h2;h3;pre',
            removeDialogTabs: 'image:advanced;link:advanced',
            toolbar: [{
              name: 'clipboard',
              items: ['Undo', 'Redo']
            },
              {
                name: 'styles',
                items: ['Styles', 'Format']
              },
              {
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Strike', '-', 'RemoveFormat']
              },
              {
                name: 'paragraph',
                items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote']
              },
              {
                name: 'links',
                items: ['Link', 'Unlink']
              },
              {
                name: 'insert',
                items: ['Image', 'Table']
              },
              {
                name: 'tools',
                items: ['Maximize']
              },
              {
                name: 'editing',
                items: ['Scayt']
              }
            ],
          }}
        ></CKEditor>
        {this.getErrors()}
      </div>

    );
  }
}




// WEBPACK FOOTER //
// ./src/сomponents/CKEditor/index.js